import withNthBrandsPageProps from 'viewModel/brand/nthBrandsPage/withNthBrandsPageProps';
import NthBrandsPage from 'components/Brand/NthBrandsPage/NthBrandsPage';

export default withNthBrandsPageProps(NthBrandsPage);
